import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';
import DocumentMeta from 'react-document-meta';

export default class SponsorsList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let sponsors = this.props.sponsors;
    let sponsorLink;

    let sponsorList = sponsors.map((sponsor, idx) => {

      // Filter out Platinum Sponsors
      if (sponsor.category_name == 'Platinum') {
        return;
      }

      if (sponsor.sponsor_website_url != '') {
        sponsorLink = <div>
          <a href={sponsor.sponsor_website_url}><img src={sponsor.sponsor_logo} /></a>
        </div>;
      } else {
        sponsorLink = <div><img src={sponsor.sponsor_logo} /></div>;
      }

      return <div className="sponsorWrapper">
        {sponsorLink}
      </div>;
    });

    return(
      <div className="girlsFestivalSponsors-sponsorList">
        {sponsorList}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/festival/sponsors/SponsorsList.jsx